// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect } from 'react'
// import InputLabel from '@mui/material/InputLabel'
// import MenuItem from '@mui/material/MenuItem'
// import FormControl from '@mui/material/FormControl'
// import Select from '@mui/material/Select'
// import ManageSearchIcon from '@mui/icons-material/ManageSearch'
// import Box from '@mui/material/Box'
// import Button from '@mui/material/Button'
// import Container from '@mui/material/Container'
// import TableStudyResultsOne from '../components/TableStudyResultsOne'
// import TableStudyResultsTwo from '../components/TableStudyResultsTwo'
// import { toast } from 'react-toastify'
// import { useLocation, useNavigate } from 'react-router-dom'
// import Axios from 'axios'

// import ToPrintPageStudyResultsOne from '../components/ToPrintPageStudyResultsOne'
// import ToPrintPageStudyResultsTwo from '../components/ToPrintPageStudyResultsTwo'

// export default function PageStudyResults() {
//   // const classToselected = useSelector(state => state.class)
//   const courId = localStorage.getItem('AccessRights').substring(11, 14)
//   const navigate = useNavigate()
//   const token = JSON.parse(localStorage.getItem('token'))
//   const token1 = localStorage.getItem('token')
//   const id = localStorage.getItem('AccessRights')
//   const Access = localStorage.getItem('Access')
//   const location = useLocation()

//   const [classNo, setClassno] = useState([])
//   const [selectedClass, setSelectedClass] = useState('')
//   const [selectedClass1, setSelectedClass1] = useState('')
//   const [selectedSeminar, setSelectedSeminar] = useState('0')
//   // const [seminar, setSeminar] = useState('0');
//   const [seminar, setSeminar] = useState(location.state ===null ?'0':location.state.seminar);
//   const [isSubmit, setIssubmit] = useState(false)
//   const [chkAttFile, setchkAttFile] = useState([])
//   let [chkSendScore, setchkSendScore] = useState([])
//   const [courseNum, setcourseNum] = useState('')
//   const [dropdownitems, setDropDownList] = useState([]);

//   useEffect(() => {
//     loadSubject2()
//     loadClass()
//     chkAttachFile()
//     // chkSendScoreE()
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [chkSendScore, selectedClass1])

//   useEffect(() => {
//     chkSendScoreE()
//     // chkButton()
//   },[selectedClass1, chkAttFile])

//   /*--------------- get data to create dropdown list ---------------*/
//   useEffect(() => {
//     (async () => {
//       try {
//         const courId = localStorage.getItem('AccessRights').substring(11, 14)
//         let resdata = await Axios.get(process.env.REACT_APP_API + `/PageAttribute/${courId}?token=${token}`);
//         resdata.data.seminar.unshift('ทุกสัมมนา'); //---added on 26.09.2022
//         // console.log("data SeminarList A: ", resdata.data)
//         if (resdata.data !== undefined) {
//           setDropDownList(resdata.data);
//           // console.log("data1: ",resdata.data);
//         }
//       } catch (err) {
//         if(err.response.status === 400) {
//           toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
//           localStorage.clear();
//           navigate('/')
//         } else {
//           console.log("err: ", err.response.data)
//         }
//       }
//     })();
//   }, [setDropDownList]);

//   const loadClass = () => {
//     Axios.get(process.env.REACT_APP_API + `/education/${courId}?token=${token}`)
//       .then((res) => {
//         setClassno(res.data)
//         //  console.log(res.data);
//       })
//       .catch((err) => {
//         if(err.response.status === 400) {
//           // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
//           localStorage.clear();
//           navigate('/')
//         } else {
//           console.log("err: ", err.response.data)
//         }
//       })

//     if (location.state !== null) {
//       const { coursegrp, seminar, courseNum } = location.state
//       setSelectedClass(coursegrp)
//       setSelectedSeminar(seminar)
//       setcourseNum(courseNum)
//       setIssubmit(true)
//     }
//   }

//   const loadSubject2 = async () => {
//     Axios.get(process.env.REACT_APP_API + `/subjects2/${courId}?token=${token}`)
//       .then((res) => {
//         // setNumSubject(res.data)
//         setcourseNum(res.data.length)
//         //  console.log("courId: ",res.data);
//       })
//       .catch((err) => console.log(err))
//   }

//   const chkAttachFile = async () => {
//     Axios.get(process.env.REACT_APP_API + `/chkAttachFile/${id}?token=${token}`)
//       .then((res) => {
//         setchkAttFile(res.data[0]);
//         // console.log("AttFile: ",res.data[0]);
//       })
//       .catch((err) => {
//         if(err.response.status === 400) {
//           // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
//           localStorage.clear();
//           navigate('/')
//         } else {
//           console.log("err: ", err.response.data)
//         }
//       })
//   }

//   const chkSendScoreE = async () => {
//     // const class = selectedClass2 === '' ? selectedClass2
//     Axios.get(process.env.REACT_APP_API + `/chkSendScore/${id}/${selectedClass1}?token=${token}`)
//       .then((res) => {
//         setchkSendScore(res.data[0]);
//         // console.log("chkSendScoreE: ",res.data[0]);
//       })
//       .catch((err) => {
//         if(err.response.status === 400) {
//         toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
//         localStorage.clear();
//         navigate('/')
//       } else {
//         console.log("err: ", err.response)
//       }
//       })
//   }

//   // console.log("chkSendScore: ",chkSendScore);
//   // console.log("Chksendscore1: ",chkSendScore.Chksendscore);
//   // console.log("chkAttFile: ",chkAttFile);

//   const handleChangeClass = (event) => {
//     setSelectedClass(event.target.value)
//     setIssubmit(false)
//   }

//   const handleChangeClass1 = (event) => {
//     setSelectedClass1(event.target.value)
//     setIssubmit(false)
//   }

//   // const handleChangeClass2 = (event) => {
//   //   setSelectedClass2(event.target.value)
//   //   setIssubmit(false)
//   // }

//   const handleChangeSeminar = (event, child) => {
//     const arr = Object.values(child)[4].children.split(' ');
//     // console.log("dataAtt: ", event.target.value)
//     // console.log("arr: ", arr)
//     setSeminar(event.target.value === 0 ? 0 : parseInt(arr[1]));
//     setSelectedSeminar(event.target.value === 0 ? 0 : dropdownitems.seminar.findIndex((e) => e.includes(arr[1])));
//     // setSelectedSeminar(event.target.value)
//     setIssubmit(false)
//   }

//   const onCilckSelect = (classNo, seminarNo) => {
//     if (classNo === '' || seminarNo === '') {
//       toast.error('กรุณาเลือกรุ่นและสัมมนา')
//       setIssubmit(false)
//     } else {
//       setIssubmit(true)
//     }
//     return isSubmit
//   }

//   const onCilckAttachFile = (e, id) => {
//     // e.preventDefault();
//    if (selectedClass1 === '') {
//     toast.error("กรุณาเลือกรุ่นก่อนแนบลายเซ็น")
//     }  else if (chkAttFile === undefined) {
//     // }  else if (chkAttFile === undefined||chkSendScore === undefined) {
//       toast.error("กรุณา UPLOAD ลายเซ็นอิเล็กทรอนิกส์ก่อนแนบลายเซ็น")
//     } else {
//         Axios.put(process.env.REACT_APP_API + `/attachFile/${id}/${selectedClass1}?token=${token1}`)
//         .then((res) => {
//           chkAttachFile()
//           toast.success("ระบบได้ทำการแนบลายเซ็นอิเล็กทรอนิกส์เรียบร้อยแล้ว")
//         })
//         .catch((err) => {
//           if(err.response.status === 400) {
//           toast.error("กรุณาเข้าระบบใหม่อีกครั้ง เพื่อแนบลายเซ็น");
//           localStorage.clear();
//           navigate('/')
//         } else {
//           // console.log("err: ", err.response.data)
//           toast.error(err.response.data.msg)
//         }
//         })
//     }
//   }
//   const onCilckSendScore = (e, id) => {
//     chkSendScoreE()
//     if (selectedClass1 === '') {
//       toast.error("กรุณาเลือกรุ่นก่อนส่งคะแนน")
//       chkSendScoreE()
//     } else if (chkSendScore === undefined) {
//       toast.error("กรุณาเข้าสิทธิ์ ผอ. เพื่อแนบลายเซ็นอิเล็กทรอนิกส์ก่อนส่งคะแนน")
//     } else {
//         Axios.put(process.env.REACT_APP_API + `/sendScore/${id}/${selectedClass1}?token=${token1}`)
//         .then((res) => {
//           chkSendScoreE()
//         setIssubmit(false)
//         toast.success("ระบบได้ทำการส่งคะแนนเรียบร้อยแล้ว")
//         })
//         .catch((err) => {
//           if(err.response.status === 400) {
//           toast.error("กรุณาเข้าระบบใหม่อีกครั้ง เพื่อส่งคะแนน");
//           localStorage.clear();
//           navigate('/')
//         } else {
//           console.log("err: ", err.response.data)
//         }
//         })
//     }
//   }

//   //เช็คแนบไฟล์ลายเซ็น
//   const txtBT = chkSendScore !== undefined ? chkSendScore.Chkattackfile : '0'
//   const txtBT1 = txtBT === '1' ? true : false
//   //เช็คส่งคะแนน
//   const txtBT2 = chkSendScore !== undefined ? chkSendScore.Chksendscore : '0'
//   const txtBT3 = txtBT2 === '1' ? true : false

//   // const courseNum = numSubject.length
//   // console.log("courseNum: ",courseNum)

//   const selectClass = [...new Set(classNo.map((item) => item.CourseGrp))]

//   return (
//     <React.Fragment>
//       <div className="cotainerDetail">
//         <p className="HeadTextMain">รายงานผลการศึกษา</p>
//         <div className="DropdownSelectModel">
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               flexDirection: 'row',
//             }}
//           >
//             <FormControl sx={{ m: 1, minWidth: 100 }}>
//               <InputLabel htmlFor="grouped-select">รุ่น</InputLabel>
//               <Select
//                 defaultValue=""
//                 id="grouped-select"
//                 label="รุ่น"
//                 onChange={handleChangeClass}
//                 value={selectedClass}
//               >
//                 <MenuItem value="">
//                   <em>None</em>
//                 </MenuItem>
//                 {selectClass.map((items, index) => (
//                   <MenuItem key={index} value={items}>
//                     {items}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl sx={{ m: 1, minWidth: 100 }}>
//               <InputLabel htmlFor="grouped-select">สัมมนา</InputLabel>
//               <Select
//                 defaultValue=""
//                 id="grouped-select"
//                 label="สัมมนา"
//                 onChange={handleChangeSeminar}
//                 value={selectedSeminar}
//               >
//                 {dropdownitems.seminar?.map((item, index) => {
//                   return (
//                     <MenuItem
//                       key={index}
//                       value={index}
//                       sx={{
//                         fontFamily: 'THSarabunNew',
//                         fontWeight: 'bold',
//                         fontSize: 16,
//                       }}
//                     >
//                       {item}
//                     </MenuItem>
//                   );
//                 })}
//               </Select>
//             </FormControl>
//             <Button
//               onClick={(e) => onCilckSelect(selectedClass, selectedSeminar)}
//               variant="contained"
//               sx={{
//                 minWidth: 100,
//                 minHeight: 55,
//                 m: 1,
//                 fontFamily: 'THSarabunNew',
//                 fontWeight: 'bold',
//                 fontSize: 16,
//               }}
//               startIcon={<ManageSearchIcon />}
//             >
//               ตกลง
//             </Button>
//           </Box>
//         </div>
//         {
//           courId === '074' || courId === '075' || courId === '082' || courId === '083' ? (
//             <Container>
//           <ToPrintPageStudyResultsOne
//             dataToPrint={{
//               courseid: courId,
//               coursegrp: selectedClass,
//               seminar: seminar,
//               courseNum: courseNum,
//               isSubmit: isSubmit,
//             }}
//           />
//           <h3>ผนวก ข (แบบ ร้อยละ)</h3>
//           <TableStudyResultsOne
//             classNo={selectedClass}
//             seminarNo={seminar}
//             isSubmit={isSubmit}
//             courseNum={courseNum}
//             chkAttFile={chkAttFile}
//           />
//         </Container>
//           ) : (
//             <Container>
//           <ToPrintPageStudyResultsTwo
//             dataToPrint={{
//               courseid: courId,
//               coursegrp: selectedClass,
//               seminar: seminar,
//               courseNum: courseNum,
//               isSubmit: isSubmit,
//             }}
//           />
//           <h3>ผนวก ค (แบบ เกรด)</h3>
//           <TableStudyResultsTwo
//             classNo={selectedClass}
//             seminarNo={seminar}
//             isSubmit={isSubmit}
//             courseNum={courseNum}
//             chkAttFile={chkAttFile}
//           />
//         </Container>
//           )
//         }
//         {Access === 'ผอ.' ? (
//           <Box sx={{ margin: '10px' }}>
//             <FormControl sx={{ m: 1, minWidth: 100 }}>
//               <InputLabel htmlFor="grouped-select">รุ่น</InputLabel>
//               <Select
//                 defaultValue=""
//                 id="grouped-select"
//                 label="รุ่น"
//                 onChange={handleChangeClass1}
//                 value={selectedClass1}
//               >
//                 <MenuItem value="">
//                   <em>None</em>
//                 </MenuItem>
//                 {selectClass.map((items, index) => (
//                   <MenuItem key={index} value={items}>
//                     {items}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <Button variant="contained"
//             onClick={(e) => onCilckAttachFile(e,id)}
//             disabled={txtBT1}
//             >
//               <Box>
//                 {!txtBT1 ?
//                   <Box sx={{ fontSize: '18px', fontWeight: 'bold' }}>
//                   แนบลายเซ็นอิเล็กทรอนิกส์
//                 </Box>
//                   :
//                  <Box sx={{ fontSize: '18px', fontWeight: 'bold' }}>
//                   แนบลายเซ็นอิเล็กทรอนิกส์เรียบร้อยแล้ว
//                 </Box>
//                  }
//                 <Box>กดเมื่อสิ้นสุดกาารศึกษา</Box>
//               </Box>{' '}
//             </Button>
//           </Box>
//         ) : Access === 'วัดผลส่วนกลาง' ? (
//           <Box sx={{ margin: '10px' }}>
//             <FormControl sx={{ m: 1, minWidth: 100 }}>
//               <InputLabel htmlFor="grouped-select">รุ่น</InputLabel>
//               <Select
//                 defaultValue=""
//                 id="grouped-select"
//                 label="รุ่น"
//                 onChange={handleChangeClass1}
//                 value={selectedClass1}
//               >
//                 <MenuItem value="">
//                   <em>None</em>
//                 </MenuItem>
//                 {selectClass.map((items, index) => (
//                   <MenuItem key={index} value={items}>
//                     {items}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <Button variant="contained"
//             onClick={(e) => onCilckSendScore(e,id)}
//             disabled={txtBT3}
//               // chkSendScore !== undefined ?
//             // false: chkSendScore ?
//             // false: !chkSendScore ?
//             // true: false
//           // }

//         // กรณีแรก เลือกรุ่นแนบไฟล์ และไม่ upload ไฟล์ เห็นปุ่มส่งคะแนน
//         //         ใช้ disabled ปุ่ม : chkSendScore === [] ? true: false  ---> false
//         //         ใช้ เปลี่ยนข้อความปุ่ม chkSendScore === undefined || chkSendScore ? ---> true
//         // กรณีสอง กดปุ่มส่งคะแนนไป upload ค่าในตาราง และเปลี่ยนปุ่มเป็น disabled และเปลี่ยนข้อความ
//         //     ส่งคะแนนเรียบร้อยแล้ว
//         //         ใช้ disabled ปุ่ม : {chkSendScore !== [] ? true: false  ---> true
//         //         ใช้ เปลี่ยนข้อความปุ่ม !chkSendScore ? ---> false
//         // กรณีสาม แสดงปุ่มกดกรณีส่งคะแนนแล้ว เป็น disabled ปุ่ม พร้อมเปลี่ยนข้อความปุ่ม และ
//         //     กรณีรุ่นยังไม่ upload ลายเซ็นอิเล็กทรอนิกส์
//         //         ใช้ disabled ปุ่ม : chkSendScore !== undefined ? true: false ---> true, false
//         //         ใช้ เปลี่ยนข้อความปุ่ม !chkSendScore ? ---> true, false

//             >
//               <Box>
//               {!txtBT3 ?
//               // {chkSendScore === "undefined" || !chkSendScore ?
//                 <Box sx={{ fontSize: '18px', fontWeight: 'bold' }}>
//                   ส่งคะแนน
//                 </Box>
//                 :
//                 <Box sx={{ fontSize: '18px', fontWeight: 'bold' }}>
//                  ส่งคะแนนเรียบร้อยแล้ว
//                </Box>
//                 }
//                 <Box>กดเมื่อสิ้นสุดกาารศึกษา</Box>
//               </Box>{' '}
//             </Button>
//           </Box>
//         ) : (
//           ''
//         )}
//       </div>
//     </React.Fragment>
//   )
// }

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Axios from "axios";

import TableStudyResultsOne from "../components/TableStudyResultsOne";
import TableStudyResultsTwo from "../components/TableStudyResultsTwo";
import ToPrintPageStudyResultsOne from "../components/ToPrintPageStudyResultsOne";
import ToPrintPageStudyResultsTwo from "../components/ToPrintPageStudyResultsTwo";

export default function PageStudyResults() {
  const courId = localStorage.getItem("AccessRights")?.substring(11, 14);
  const token = JSON.parse(localStorage.getItem("token"));
  const token1 = localStorage.getItem("token");
  const id = localStorage.getItem("AccessRights");
  const Access = localStorage.getItem("Access");
  const location = useLocation();
  const navigate = useNavigate();

  const [classNo, setClassno] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedClass1, setSelectedClass1] = useState("");
  const [seminar, setSeminar] = useState(location?.state?.seminar || "0");
  const [selectedSeminar, setSelectedSeminar] = useState("0");
  const [isSubmit, setIsSubmit] = useState(false);
  const [chkAttFile, setChkAttFile] = useState([]);
  const [chkSendScore, setChkSendScore] = useState([]);
  const [courseNum, setCourseNum] = useState("");
  const [dropdownItems, setDropdownItems] = useState([]);

  const fetchData = async () => {
    try {
      const [classRes, subjectRes, attachRes] = await Promise.all([
        Axios.get(
          `${process.env.REACT_APP_API}/education/${courId}?token=${token}`
        ),
        Axios.get(
          `${process.env.REACT_APP_API}/subjects2/${courId}?token=${token}`
        ),
        Axios.get(
          `${process.env.REACT_APP_API}/chkAttachFile/${id}?token=${token}`
        ),
      ]);

      setClassno(classRes.data);
      setCourseNum(subjectRes.data.length);
      setChkAttFile(attachRes.data[0]);

      if (location.state) {
        const { coursegrp, seminar, courseNum } = location.state;
        setSelectedClass(coursegrp);
        setSeminar(seminar);
        setCourseNum(courseNum);
        setIsSubmit(true);
      }
    } catch (err) {
      handleAuthError(err);
    }
  };

  const handleAuthError = (err) => {
    if (err.response?.status === 400) {
      toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
      localStorage.clear();
      navigate("/");
    } else {
      console.error("Error:", err);
    }
  };

  const fetchDropdown = async () => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API}/PageAttribute/${courId}?token=${token}`
      );
      if (res.data) {
        res.data.seminar.unshift("ทุกสัมมนา");
        setDropdownItems(res.data);
      }
    } catch (err) {
      handleAuthError(err);
    }
  };

  const chkSendScoreE = async () => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API}/chkSendScore/${id}/${selectedClass1}?token=${token}`
      );
      setChkSendScore(res.data[0]);
    } catch (err) {
      handleAuthError(err);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDropdown();
  }, []);

  useEffect(() => {
    chkSendScoreE();
  }, [selectedClass1]);

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
    setIsSubmit(false);
  };

  const handleSeminarChange = (event, child) => {
    const seminarValue = child?.props?.children?.split(" ")[1] || "0";
    setSeminar(event.target.value === 0 ? "0" : parseInt(seminarValue));
    setSelectedSeminar(event.target.value);
    setIsSubmit(false);
  };

  const handleSelectClick = () => {
    if (!selectedClass || !selectedSeminar) {
      toast.error("กรุณาเลือกรุ่นและสัมมนา");
    } else {
      setIsSubmit(true);
    }
  };

  const handleAction = async (actionType) => {
    if (!selectedClass1) {
      toast.error("กรุณาเลือกรุ่นก่อนดำเนินการ");
      return;
    }

    try {
      const endpoint =
        actionType === "attach"
          ? `/attachFile/${id}/${selectedClass1}?token=${token1}`
          : `/sendScore/${id}/${selectedClass1}?token=${token1}`;
      await Axios.put(`${process.env.REACT_APP_API}${endpoint}`);
      if (actionType === "attach") {
        setChkAttFile((prev) => ({ ...prev, Chkattackfile: "1" }));
        toast.success("แนบลายเซ็นอิเล็กทรอนิกส์เรียบร้อยแล้ว");
      } else {
        setChkSendScore((prev) => ({ ...prev, Chksendscore: "1" }));
        toast.success("ส่งคะแนนเรียบร้อยแล้ว");
      }
    } catch (err) {
      handleAuthError(err);
    }
  };

  const txtBT = chkSendScore?.Chkattackfile === "1";
  const txtBT3 = chkSendScore?.Chksendscore === "1";
  const selectClass = [...new Set(classNo.map((item) => item.CourseGrp))];

  return (
    <div className="cotainerDetail">
      <p className="HeadTextMain">รายงานผลการศึกษา</p>
      <Box
        sx={{ display: "flex", justifyContent: "center", flexDirection: "row" }}
      >
        <FormControl sx={{ m: 1, minWidth: 100 }}>
          <InputLabel>รุ่น</InputLabel>
          <Select
            value={selectedClass}
            onChange={handleChange(setSelectedClass)}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {selectClass.map((item, i) => (
              <MenuItem key={i} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 100 }}>
          <InputLabel>สัมมนา</InputLabel>
          <Select value={selectedSeminar} onChange={handleSeminarChange}>
            {dropdownItems.seminar?.map((item, i) => (
              <MenuItem key={i} value={i}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={handleSelectClick}
          variant="contained"
          sx={{ minWidth: 100, minHeight: 55, m: 1 }}
          startIcon={<ManageSearchIcon />}
        >
          ตกลง
        </Button>
      </Box>

      <Container>
        {["074", "075", "082", "083"].includes(courId) ? (
          <>
            <ToPrintPageStudyResultsOne
              dataToPrint={{
                courseid: courId,
                coursegrp: selectedClass,
                seminar,
                courseNum,
                isSubmit,
              }}
            />
            <h3>ผนวก ข (แบบ ร้อยละ)</h3>
            <TableStudyResultsOne
              classNo={selectedClass}
              seminarNo={seminar}
              isSubmit={isSubmit}
              courseNum={courseNum}
              chkAttFile={chkAttFile}
            />
          </>
        ) : (
          <>
            <ToPrintPageStudyResultsTwo
              dataToPrint={{
                courseid: courId,
                coursegrp: selectedClass,
                seminar,
                courseNum,
                isSubmit,
              }}
            />
            <h3>ผนวก ค (แบบ เกรด)</h3>
            <TableStudyResultsTwo
              classNo={selectedClass}
              seminarNo={seminar}
              isSubmit={isSubmit}
              courseNum={courseNum}
              chkAttFile={chkAttFile}
            />
          </>
        )}
      </Container>

      {(Access === "ผอ." || Access === "วัดผลส่วนกลาง") && (
        <Box sx={{ margin: "10px" }}>
          <FormControl sx={{ m: 1, minWidth: 100 }}>
            <InputLabel>รุ่น</InputLabel>
            <Select
              value={selectedClass1}
              onChange={handleChange(setSelectedClass1)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {selectClass.map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={() => handleAction(Access === "ผอ." ? "attach" : "send")}
            disabled={Access === "ผอ." ? txtBT : txtBT3}
          >
            <Box>
              <Box sx={{ fontSize: "18px", fontWeight: "bold" }}>
                {Access === "ผอ."
                  ? txtBT
                    ? "แนบลายเซ็นอิเล็กทรอนิกส์เรียบร้อยแล้ว"
                    : "แนบลายเซ็นอิเล็กทรอนิกส์"
                  : txtBT3
                  ? "ส่งคะแนนเรียบร้อยแล้ว"
                  : "ส่งคะแนน"}
              </Box>
              <Box>กดเมื่อสิ้นสุดกาารศึกษา</Box>
            </Box>
          </Button>
        </Box>
      )}
    </div>
  );
}
